import { ComponentChildren } from 'preact';
import { useConveyorBeltItem } from './useConveyorBeltItem';
import { styles } from './themes/ConveyorBeltStyles.css';
import { classNames as clsx } from '../utils/UNSAFE_classNames';

type ConveyorBeltItemProps = {
  /**
   * The ConveyorBeltItem content
   */
  children?: ComponentChildren;
  /**
   * Specifies the current item which should be scrolled into view
   */
  isCurrent?: boolean;
};
/**
 * A wrapper component for one conveyor belt item/child element.
 * It takes care of correctly mark the child components as conveyor belt items.
 * @param param0 ConveyorBeltItemProps
 * @returns
 */
export const ConveyorBeltItem = ({ children, isCurrent }: ConveyorBeltItemProps) => {
  const props = useConveyorBeltItem({
    isCurrent: isCurrent
  });
  return (
    <div className={clsx([styles.conveyorBeltItemStyle])} {...props}>
      {children}
    </div>
  );
};
